<button type="button" mat-icon-button routerLink="user/notifications">
  <mat-icon [matBadge]="_count.unread()" matBadgeColor="accent" matBadgePosition="above after" [matBadgeHidden]="_count.unread() === 0" aria-hidden="false">notifications</mat-icon>
</button>
